// File: whatsapp.service-errors.js
export const ERROR_MESSAGES = {
    MESSAGE_FETCH_FAILED: 'Failed to fetch WhatsApp messages',
    SEND_MESSAGE_FAILED: 'Failed to send WhatsApp message',
    SEND_FILE_FAILED: 'Failed to send WhatsApp file',
    PROFILE_FETCH_FAILED: 'Failed to fetch WhatsApp profile',
    NETWORK_ERROR: 'Network error occurred while connecting to WhatsApp server',
    SERVER_ERROR: 'WhatsApp server error',
    UNAUTHORIZED: 'Invalid secret key or unauthorized access',
    GROUP_CREATE_FAILED: 'Failed to create WhatsApp group',
    GROUP_UPDATE_FAILED: 'Failed to update WhatsApp group',
    INVITE_INFO_FAILED: 'Failed to get WhatsApp group invite info'
  };